import {
  CardBodyProps,
  CardFooterProps,
  CardHeaderProps,
  CardRootProps,
  Card as ChakraCard,
} from '@chakra-ui/react'
import { ReactNode, forwardRef } from 'react'

export interface Props extends Omit<CardRootProps, 'children'> {
  bodyProps?: Omit<CardBodyProps, 'children'>
  body?: ReactNode
  footerProps?: Omit<CardFooterProps, 'children'>
  footer?: ReactNode
  headerProps?: Omit<CardHeaderProps, 'children'>
  header?: ReactNode
}

export default forwardRef<HTMLDivElement, Props>(
  ({ body, bodyProps, footer, footerProps, header, headerProps, ...rest }, ref) => {
    return (
      <ChakraCard.Root borderWidth={0} ref={ref} {...rest}>
        {header && (
          <ChakraCard.Header p={0} {...headerProps}>
            {header}
          </ChakraCard.Header>
        )}
        {body && (
          <ChakraCard.Body px={5} pt={5} {...bodyProps}>
            {body}
          </ChakraCard.Body>
        )}
        {footer && <ChakraCard.Footer {...footerProps}>{footer}</ChakraCard.Footer>}
      </ChakraCard.Root>
    )
  }
)
